<div *ngIf="formGroup" class="form-row">
  <div class="col-2 col-quantity" [ngClass]="{ 'col-md': !isSidebar, 'is-sidebar': isSidebar }">
    <app-control-wrapper [control]="formGroup.get(['quantity'])" [errors]="errors" [isShowHelper]="false">
      <label [for]="'package-quantity-' + index" control-label>{{ "LABELS.QTY" | translate }}</label>
      <input
        type="text"
        [formControl]="formGroup.get(['quantity'])"
        class="form-control"
        [id]="'package-quantity-' + index"
        [name]="'package-quantity-' + index"
        [mask]="numberInputData.mask"
        [attr.pattern]="numberInputData.pattern"
        [appMaskErrorTooltip]="numberInputData.maskErrorTooltip"
        control-wrapper
      />
    </app-control-wrapper>
  </div>

  <div class="col-10" [ngClass]="{ 'col-md': !isSidebar }">
    <app-control-wrapper [control]="formGroup.get(['type'])" [errors]="typeErrors" [isShowHelper]="false">
      <label [for]="'package-type-' + index" control-label>{{ "LABELS.PACKAGE_TYPE" | translate }}</label>
      <ng-select
        class="custom"
        [formControl]="formGroup.get('type')"
        control-wrapper
        bindLabel="label"
        bindValue="value"
        [items]="typeSelect"
        [id]="'package-type-' + index"
        [clearable]="false"
        [searchable]="false"
      ></ng-select>
    </app-control-wrapper>
  </div>

  <div class="col-12 col-dimensions" [ngClass]="{ 'col-md': !isSidebar, 'is-sidebar': isSidebar, 'col-lg-8': isSidebar }">
    <div class="d-flex form-control-group">
      <app-control-wrapper [control]="formGroup.get(['dimensions', 'length'])" [errors]="errors" [isShowHelper]="false">
        <label [for]="'package-length-' + index" control-label>{{ "LABELS.LENGTH" | translate }}</label>
        <input
          type="text"
          inputmode="numeric"
          class="form-control length"
          control-wrapper
          [formControl]="formGroup.get(['dimensions', 'length'])"
          [id]="'package-length-' + index"
          [name]="'package-length-' + index"
          [mask]="decimalInputData.mask"
          [attr.pattern]="decimalInputData.pattern"
          [appMaskErrorTooltip]="decimalInputData.maskErrorTooltip"
          [dropSpecialCharacters]="false"
        />
      </app-control-wrapper>

      <app-control-wrapper [control]="formGroup.get(['dimensions', 'width'])" [errors]="errors" [isShowHelper]="false">
        <label [for]="'package-width-' + index" control-label>{{ "LABELS.WIDTH" | translate }}</label>
        <input
          type="text"
          inputmode="numeric"
          class="form-control width"
          control-wrapper
          [formControl]="formGroup.get(['dimensions', 'width'])"
          [id]="'package-width-' + index"
          [name]="'package-width-' + index"
          [mask]="decimalInputData.mask"
          [attr.pattern]="decimalInputData.pattern"
          [appMaskErrorTooltip]="decimalInputData.maskErrorTooltip"
          [dropSpecialCharacters]="false"
        />
      </app-control-wrapper>

      <app-control-wrapper [control]="formGroup.get(['dimensions', 'height'])" [errors]="errors" [isShowHelper]="false">
        <label [for]="'package-height-' + index" control-label>{{ "LABELS.HEIGHT" | translate }}</label>
        <input
          type="text"
          inputmode="numeric"
          class="form-control height"
          control-wrapper
          [formControl]="formGroup.get(['dimensions', 'height'])"
          [id]="'package-height-' + index"
          [name]="'package-height-' + index"
          [mask]="decimalInputData.mask"
          [attr.pattern]="decimalInputData.pattern"
          [appMaskErrorTooltip]="decimalInputData.maskErrorTooltip"
          [dropSpecialCharacters]="false"
        />
      </app-control-wrapper>

      <app-control-wrapper [control]="formGroup.get(['lengthUnit'])" [errors]="errors" [isShowHelper]="false">
        <label [for]="'package-lengthUnit-' + index" control-label></label>
        <ng-select
          class="custom blue unit"
          control-wrapper
          [formControl]="formGroup.get('lengthUnit')"
          [id]="'package-lengthUnit-' + index"
          [items]="lengthUnits"
          [clearable]="false"
          [searchable]="false"
        >
          <ng-template ng-option-tmp let-item="item">
            {{ item | lengthUnit | translate }}
          </ng-template>
          <ng-template ng-label-tmp let-item="item">
            {{ item | lengthUnit | translate }}
          </ng-template>
        </ng-select>
      </app-control-wrapper>
    </div>
  </div>

  <div class="col-12 col-weight" [ngClass]="{ 'col-md': !isSidebar, 'is-sidebar': isSidebar, 'col-lg-4': isSidebar }">
    <div class="d-flex form-control-group">
      <app-control-wrapper [control]="formGroup.get(['weight'])" [errors]="errors" [isShowHelper]="false">
        <label [for]="'package-weight-' + index" control-label>{{ "LABELS.WEIGHT" | translate }}</label>
        <input
          type="text"
          inputmode="numeric"
          class="form-control weight"
          control-wrapper
          [formControl]="formGroup.get(['weight'])"
          [id]="'package-weight-' + index"
          [name]="'package-weight-' + index"
          [mask]="decimalInputData.mask"
          [attr.pattern]="decimalInputData.pattern"
          [appMaskErrorTooltip]="decimalInputData.maskErrorTooltip"
          [dropSpecialCharacters]="false"
        />
      </app-control-wrapper>
      <app-control-wrapper [control]="formGroup.get(['weightUnit'])" [errors]="errors" [isShowHelper]="false">
        <label [for]="'package-weightUnit-' + index" control-label></label>
        <ng-select
          class="custom blue unit"
          [formControl]="formGroup.get('weightUnit')"
          control-wrapper
          [id]="'package-weightUnit-' + index"
          [items]="weightUnits"
          [clearable]="false"
          [searchable]="false"
        >
          <ng-template ng-option-tmp let-item="item">
            {{ item | weightUnit | translate }}
          </ng-template>
          <ng-template ng-label-tmp let-item="item">
            {{ item | weightUnit | translate }}
          </ng-template>
        </ng-select>
      </app-control-wrapper>
    </div>
  </div>

  <div class="col-stackable" [ngClass]="{ 'col-lg': !isSidebar, 'col-6 is-sidebar': isSidebar }">
    <app-control-wrapper [control]="formGroup.get(['stackable'])" [errors]="errors" [isShowHelper]="false">
      <label [for]="'package-stackable-' + index" control-label class="d-none d-md-inline">
        {{ "LABELS.STACKABLE" | translate }}
      </label>
      <div control-wrapper class="custom-control custom-checkbox mt-1">
        <input
          type="checkbox"
          [formControl]="formGroup.get('stackable')"
          class="custom-control-input"
          [id]="'package-stackable-' + index"
        />
        <label class="custom-control-label" [for]="'package-stackable-' + index">
          <span class="d-md-none">{{ "LABELS.STACKABLE" | translate }}</span>
        </label>
      </div>
    </app-control-wrapper>
  </div>

  <div class="col-buttons" [ngClass]="{ 'сol-lg text-sm-right text-lg-left': !isSidebar, 'col-6 text-right is-sidebar': isSidebar }">
    <button class="btn btn-outline-secondary btn-clean-form" [disabled]="isAdminView ? false : isLastest" (click)="onRemoveQuote()">
      <i class="fa fa-trash"></i>
    </button>
  </div>
</div>
